<template>
  <v-card>
    <v-data-table :headers="headers" :items="databyclosecasebyadmin">
      <template #items="props">
        <td>{{ props.item.subject }}</td>
        <td class="text-xs-center">{{ props.item.received }}</td>
        <td class="text-xs-center">{{ props.item.resolved }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import { handleApiError } from '@/api/util'
export default {
  components: {},
  props: {
    filter: {
      type: Object,
      default: () => undefined
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Subject',
          align: 'start',
          sortable: false,
          value: 'subject'
        },
        { text: 'Received', value: 'received', align: 'center' },
        { text: 'Resolved', value: 'resolved', align: 'center' }
      ],
      apexchartKeyClosecase: 0,
      databyclosecasebyadmin: [],
      databyclosecase: {},
      databyclosecasebyadminwithsubject: [],
      total: 0,
      loadingDetails: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    filter: {
      handler(newValue) {
        if (newValue) {
          // this.getTicketsCloseCase()
          this.getTicketsCloseCaseDetailByAdmin()
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.filter) {
      // this.getTicketsCloseCase()
      this.getTicketsCloseCaseDetailByAdmin()
    }
  },
  methods: {
    async getTicketsCloseCaseDetailByAdmin() {
      try {
        var data = {}
        if (this.filter.pageid) {
          Object.assign(data, { page_id: this.filter.pageid })
        } else {
          Object.assign(data, { page_id: this.selectedBot.pageid })
        }

        if (this.filter.startTime) {
          Object.assign(data, { start_date: this.filter.startTime })
        }
        if (this.filter.endTime) {
          Object.assign(data, { end_date: this.filter.endTime })
        }

        if (this.filter.channel) {
          Object.assign(data, { channel: this.filter.channel.toLowerCase() || 'all' })
        }
        const response = await ticket3AgentManagementApi.getNumberOfCloseCaseDetailAdmin({
          params: data
        })
        if (response.status == 200) {
          if (response.data.data && response.data.data.length) {
            this.databyclosecasebyadmin = response.data.data
          } else this.databyclosecasebyadmin = []
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/overview/DataByCloseCase.vue